var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.71 71.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb2a31;}.cls-2{fill:#202020;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.36,7.43c1.2,0,2.17-.97,2.17-2.17v-.47c0-.24,.2-.45,.45-.45h3.51c.25,0,.46,.21,.46,.45v.47c0,1.2,.98,2.17,2.17,2.17s2.17-.97,2.17-2.17v-.47c0-2.64-2.16-4.8-4.8-4.8h-3.51c-2.64,0-4.8,2.15-4.8,4.8v.47c0,1.2,.97,2.17,2.17,2.17h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.58,23.45c-2.4-6.08-7.66-9.69-13.44-9.69-8.86,0-14.87,7.59-14.87,16.22s6.16,16.52,14.95,16.52c5.63,0,10.44-3.15,13.37-9.39h14.87c-3.46,13.37-14.95,21.86-28.09,21.86-7.74,0-15.02-2.7-20.73-8.34-6.01-5.86-8.56-12.92-8.56-21.33,0-14.72,12.69-28.01,28.61-28.01,7.66,0,13.82,2.1,19.38,6.83,5.26,4.51,8.41,9.61,9.39,15.32h-14.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.53,57.93V2.35h12.47V57.93h-12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.58,57.93v-4.51h-.15c-1.8,3.68-6.76,5.93-12.24,5.93-12.32,0-20.88-9.69-20.88-22.31s8.94-22.23,20.88-22.23c5.11,0,9.84,2.03,12.24,5.86h.15v-4.43h12.47V57.93h-12.47Zm0-20.88c0-5.86-4.73-10.59-10.59-10.59s-10.21,4.73-10.21,10.74,4.58,10.51,10.36,10.51,10.44-4.66,10.44-10.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.3,57.93V16.24h11.72v4.43h.15c2.18-4.43,5.63-5.86,10.44-5.86v12.54c-7.44,.08-9.84,2.85-9.84,7.59v22.98h-12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.46,11.81V2.35h12.47V11.81h-12.47Zm0,46.11V16.24h12.47V57.93h-12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.05,57.93V25.71h-6.16v-9.46h6.16V2.35h12.47v13.89h6.01v9.46h-6.01V57.93h-12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.61,71.82l6.61-16-15.47-39.58h13.29l8.34,24.18h.15l7.96-24.18h13.22l-20.88,55.58h-13.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.54,53.58h-3.53c-1.47,0-2.67-1.2-2.67-2.67V12.93c0-1.47,1.2-2.66,2.67-2.66H23.66c1.21,0,2.17-.98,2.17-2.17s-.97-2.17-2.17-2.17H7.01C3.14,5.92,0,9.06,0,12.93V50.91c0,3.87,3.14,7.02,7.01,7.02h3.53c1.21,0,2.17-.97,2.17-2.17s-.97-2.17-2.17-2.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.77,5.92h-3.53c-1.2,0-2.17,.97-2.17,2.17s.98,2.17,2.17,2.17h3.53c1.47,0,2.67,1.19,2.67,2.66V50.91c0,1.47-1.2,2.67-2.67,2.67h-15.56c-1.2,0-2.17,.98-2.17,2.17s.98,2.17,2.17,2.17h15.56c3.87,0,7.02-3.15,7.02-7.02V12.93c0-3.87-3.14-7.01-7.02-7.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.93,31.93c0-9.87-8.03-17.9-17.9-17.9s-17.89,8.02-17.89,17.9,8.03,17.89,17.89,17.89,17.9-8.02,17.9-17.89h0Zm-17.9,14.15c-7.8,0-14.15-6.35-14.15-14.15s6.36-14.16,14.15-14.16,14.16,6.35,14.16,14.16-6.35,14.15-14.16,14.15h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.04,
    cy: 31.92,
    r: 5.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfax);
export default __webpack_public_path__ + "static/media/efax.af1319f4d494d5443f94120290bcd207.svg";
export { ForwardRef as ReactComponent };